import { useState } from "react"

import { Button, Drawer, Flex, Modal, Typography } from "antd"
import { useSelector } from "react-redux"

import Icon from "../../../Icon"
import BusinessDetailsForm from "./BusinessDetailsForm"

const { Text } = Typography

const BusinessDetailsModal = ({ open, onClose }) => {
  const [isValidForm, setIsValidForm] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const isMobile = useSelector((state) => state.nav.isMobile)

  const formNode = (
    <BusinessDetailsForm
      onSubmit={onClose}
      setIsValidForm={setIsValidForm}
      setIsSubmitting={setIsSubmitting}
    />
  )

  if (isMobile) {
    return (
      <Drawer
        open={open}
        onClose={onClose}
        placement="bottom"
        height="100%"
        className="business-details-drawer"
        title="Business details"
        closeIcon={<Icon type="cross_small" />}
        destroyOnClose
        styles={{
          wrapper: { height: "100%" },
          body: { padding: 16, overflowY: "auto", flex: 1 },
          header: { padding: "12px 16px", flexShrink: 0 },
          footer: { padding: "12px 16px", flexShrink: 0 }
        }}
        footer={
          <Flex vertical gap={12}>
            <Button size="large" style={{ width: "100%", borderRadius: 12 }} onClick={onClose}>
              Cancel
            </Button>
            <Button
              type="primary"
              size="large"
              style={{ width: "100%", borderRadius: 12 }}
              htmlType="submit"
              form="business-details-form"
              loading={isSubmitting}
              disabled={!isValidForm}
            >
              Add business details
            </Button>
          </Flex>
        }
      >
        <Text type="secondary" style={{ display: "block", marginBottom: 16 }}>
          Kindly provide the information to display on your invoices.
        </Text>
        {formNode}
      </Drawer>
    )
  }

  return (
    <Modal
      open={open}
      centered={!isMobile}
      onClose={onClose}
      onCancel={onClose}
      okText="Add business details"
      okButtonProps={{
        htmlType: "submit",
        form: "business-details-form",
        size: "large",
        loading: isSubmitting,
        disabled: !isValidForm
      }}
      cancelButtonProps={{ size: "large" }}
      title="Business details"
      classNames={{ content: "clear-bg" }}
      className="business-details-custom-modal"
      closeIcon={<Icon type="cross_small" />}
      width={442}
      destroyOnClose
    >
      <div className="business-details-form-description">
        <Text type="secondary">Kindly provide the information to display on your invoices.</Text>
      </div>
      {formNode}
    </Modal>
  )
}

export default BusinessDetailsModal
